export const RESTRICTED_SUPPLIER_BADGE = 'Restricted Supplier'

export const RESTRICTED_SUPPLIER_EXPLAINER =
  'This order requires manager approval before it is sent.'

export const APPROVAL_PENDING_BANNER =
  'This order is awaiting manager approval.'

export const APPROVAL_REJECTED_BANNER =
  'This order was rejected by your manager.'

export const APPROVAL_AUTO_REJECTED_BANNER =
  'This order was automatically rejected because it expired without manager approval.'
